'use client'

import { RichText } from '@/components/RichText'

type SectionBlockProps = {
  blockType: 'pageSection'
  id?: string | null
  heading?: string | null
  content?: any
}

export const SectionBlockComponent: React.FC<SectionBlockProps> = ({
  heading,
  content,
}) => {
  return (
    <section className="mt-10 first:mt-0">
      {heading && (
        <h2 className="mb-4 text-xl font-semibold text-foreground sm:text-2xl">
          {heading}
        </h2>
      )}
      {content && (
        <div className="prose-content">
          <RichText data={content} enableGutter={false} enableProse={false} />
        </div>
      )}
    </section>
  )
}
